<template>
  <button
    class="border-text-gray-100 inline-flex items-center justify-center rounded-full border px-4 py-1 font-medium duration-100"
    :class="
      selected === slug
        ? 'bg-gray-100 text-gray-600'
        : 'bg-transparent text-gray-100 hover:border-white hover:bg-white/10 hover:text-white'
    "
    @click="handleClick">
    {{ title }}
  </button>
</template>

<script setup lang="ts">
  import { useRoute, useRouter } from 'vue-router'

  const props = withDefaults(defineProps<CategoryProps>(), {
    queryParam: 'category',
    queryParamPage: 'page'
  })
  const route = useRoute()
  const router = useRouter()

  type CategoryProps = {
    slug: string
    title: string
    selected: string
    queryParam?: string
    queryParamPage?: string
  }

  function handleClick() {
    if (route.query[props.queryParamPage]) {
      router.push({
        query: {
          ...route.query,
          [props.queryParam]: props.slug,
          [props.queryParamPage]: 1
        }
      })
    } else {
      router.push({
        query: {
          ...route.query,
          [props.queryParam]: props.slug
        }
      })
    }
  }
</script>
